module.exports = __webpack_public_path__ + "static/img/y54.e9982cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y54.jpg
// module id = T45M
// module chunks = 1